<mat-card class="lib-view-cont">
    <mat-card-content class="p-0">
        <app-library-item-header (unpinLibrary)="unpinLibrary()" (closeLibrary)="closeLibrary()" [title]="'LIBRARY_VIEW' | translate"></app-library-item-header>
        <div class="lib-view-body">
            <p>Library View content goes here.</p>
        </div>
    </mat-card-content>
</mat-card>